// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type JobLogsTileQueryVariables = Types.Exact<{
  filter: Types.JobLogFilter;
}>;


export type JobLogsTileQuery = { __typename?: 'Query', jobLogs: Array<{ __typename?: 'JobLog', id: string, notes: Array<{ __typename?: 'JobLogNote', id: string, title?: string | null | undefined, name: string, createdAt: Types.Scalars['DateTime']['input'], internalUser: { __typename?: 'InternalUser', id: string, avatar: string, name: string } }> }> };

export type JobLogsTile_NotesFragment = { __typename?: 'JobLogNote', id: string, title?: string | null | undefined, name: string, createdAt: Types.Scalars['DateTime']['input'], internalUser: { __typename?: 'InternalUser', id: string, avatar: string, name: string } };

export const JobLogsTile_NotesFragmentDoc = gql`
    fragment JobLogsTile_Notes on JobLogNote {
  id
  title
  name
  createdAt
  internalUser {
    id
    avatar
    name
  }
}
    `;
export const JobLogsTileDocument = gql`
    query JobLogsTile($filter: JobLogFilter!) {
  jobLogs(filter: $filter) {
    id
    notes {
      ...JobLogsTile_Notes
    }
  }
}
    ${JobLogsTile_NotesFragmentDoc}`;

/**
 * __useJobLogsTileQuery__
 *
 * To run a query within a React component, call `useJobLogsTileQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobLogsTileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobLogsTileQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useJobLogsTileQuery(baseOptions: ApolloReactHooks.QueryHookOptions<JobLogsTileQuery, JobLogsTileQueryVariables> & ({ variables: JobLogsTileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<JobLogsTileQuery, JobLogsTileQueryVariables>(JobLogsTileDocument, options);
      }
export function useJobLogsTileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<JobLogsTileQuery, JobLogsTileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<JobLogsTileQuery, JobLogsTileQueryVariables>(JobLogsTileDocument, options);
        }
// @ts-ignore
export function useJobLogsTileSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<JobLogsTileQuery, JobLogsTileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<JobLogsTileQuery, JobLogsTileQueryVariables>;
export function useJobLogsTileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<JobLogsTileQuery, JobLogsTileQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<JobLogsTileQuery | undefined, JobLogsTileQueryVariables>;
export function useJobLogsTileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<JobLogsTileQuery, JobLogsTileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<JobLogsTileQuery, JobLogsTileQueryVariables>(JobLogsTileDocument, options);
        }
export type JobLogsTileQueryHookResult = ReturnType<typeof useJobLogsTileQuery>;
export type JobLogsTileLazyQueryHookResult = ReturnType<typeof useJobLogsTileLazyQuery>;
export type JobLogsTileSuspenseQueryHookResult = ReturnType<typeof useJobLogsTileSuspenseQuery>;
export type JobLogsTileQueryResult = ApolloReactCommon.QueryResult<JobLogsTileQuery, JobLogsTileQueryVariables>;